import { AxiosError } from 'axios'
import { CommonSwitchStatus } from '@/api/common/type'
import { MusicItem } from '@/api/aside/type'
import { TranslateResult } from 'vue-i18n'
import { apiGetMusicList } from '@/api/aside'
import { createMyPersistedStorage } from '@/utils/business-utils'
import { defineStore } from 'pinia'
import { useI18n } from '@/i18n'
import { useMainStore } from '@/store/index'
import MusicAudio from '../components/musicAudio'
import Vue from 'vue'
import to from 'await-to-js'

// 循环播放|随机|单曲循环
export enum MusicPlayTypeEnum {
  xhbf = 'xhbf',
  sj = 'sj',
  dqxh = 'dqxh'
}

export interface MusicState {
  musicPlayType: MusicPlayTypeEnum
  currentMusicIndex: number
  initMusic: boolean
  sysMusicList: Array<MusicItem>
  myMusicList: Array<MusicItem>
  musicVolume: number
  musicVolumeOff: boolean
  musicPlay: boolean
  totalTime: number
  currentTime: number
  musicLoadingIds: number[]
  progressMouseDown: boolean
  progressMousePosition: number
  musicAxiosError: null | AxiosError
  musicAxiosErrorLoading: boolean
}

export const useMusicStore = defineStore('music', {
  state: (): MusicState => ({
    sysMusicList: [],
    myMusicList: [],
    musicPlayType: MusicPlayTypeEnum.xhbf,
    currentMusicIndex: 0,
    totalTime: 0,
    currentTime: 0,
    musicVolume: 0.5,
    musicVolumeOff: false,
    musicPlay: false,
    musicLoadingIds: [],
    initMusic: false,
    progressMouseDown: false,
    progressMousePosition: 0,
    musicAxiosError: null,
    musicAxiosErrorLoading: false
  }),
  getters: {
    // 当前音乐名称
    curMusicName(state): string | TranslateResult {
      const { t } = useI18n()
      const { currentMusicIndex, myMusicList } = state
      return myMusicList.length > 0
        ? myMusicList[currentMusicIndex]?.music_name
        : t(`lobby.aside.music.noMoreMusic`)
    },
    // 是否自动播放  后台设置自动播放开 & 用户音乐状态是播放
    autoplay: (state) => {
      const { musicPlay } = state
      const { systemInfos } = useMainStore()
      return systemInfos?.musicAutoPlay === CommonSwitchStatus.OPEN && musicPlay
    }
  },
  actions: {
    setMusicVolume(musicVolume: number) {
      this.musicVolume = musicVolume
    },
    createAudioCom() {
      if (!this.initMusic) {
        // 创建组件构造器
        const ComponentConstructor = Vue.extend(MusicAudio)
        // 创建组件实例
        const instance = new ComponentConstructor()
        // 挂载组件
        instance.$mount()
        const el = instance.$el as HTMLAudioElement
        document.body.appendChild(el)
        this.initMusic = true
      }
    },
    // 我的音乐 存储localStorage(历史问题)
    updateMyMusicList(list: MusicItem[]) {
      this.myMusicList = list
      const ids = list.map((item) => item?.id)
      localStorage.setItem('myMusicList', JSON.stringify(ids))
    },
    // 变更播放类型
    changeMusicPlayType() {
      const MusicPlayTypeArr = Object.values(MusicPlayTypeEnum)
      const nowTypeIndex = MusicPlayTypeArr.indexOf(this.musicPlayType)
      this.musicPlayType =
        MusicPlayTypeArr[
          nowTypeIndex === MusicPlayTypeArr.length - 1 ? 0 : nowTypeIndex + 1
        ]
    },
    async updateSysMusicList() {
      const [error, data] = await to(
        apiGetMusicList({
          reqType: 1
        })
      )
      if (error) return

      this.sysMusicList = data?.sys_list as MusicItem[]
    }
  },
  persist: {
    enabled: true,
    strategies: [
      {
        key: 'web.lobby.music',
        storage: createMyPersistedStorage(),
        paths: ['musicVolume', 'musicVolumeOff', 'musicPlay', 'sysMusicList']
      }
    ]
  }
})
